import Client from './KomodoClient';

// komodo quick start wizard: InstallController, UserSecurityController, MigrateController, BatchTaskController.
const enc = encodeURIComponent;

// UserFunctionVerifyReq → bool (IsAuthorizated)
const verify = (permissionCode, url, deptCode) =>
	Client.post('/api/user-security/function-verify', {
		permissionCode,
		url,
		deptCode,
	});
// → MerchantDataInitItemDTO[] { dataMessageResName, isSuccess }
const merchantInit = () => Client.post('/api/install/merchant-init');
const syncUsersFromZii = () => Client.get('/api/user-security/sync-from-zii');
// MigrateFBMenuRequest → taskId
const migrateMenu = (req) => Client.post('/api/migrate/menu', req);
// ClientMenuDTO (parsed sheets) → taskId
const migrateClientMenu = (dto) => Client.post('/api/migrate/client-menu', dto);
// Portal endpoint: upload the workbook and let komodo parse it (MiniExcel) → taskId
const migrateClientMenuFile = (file, fixedDeptCode) => {
	const form = new FormData();
	form.append('file', file, file.name);
	if (fixedDeptCode) form.append('fixedDeptCode', fixedDeptCode);
	return Client.post('/api/migrate/client-menu/upload', form, {
		headers: { 'Content-Type': 'multipart/form-data' },
	});
};
// → BatchTaskProgressDTO { taskId, status: 'Completed' | 'Failed' | …, processed, total, percentage, message }
const progress = (taskId) =>
	Client.get(`/api/batch-task/progress/${enc(taskId)}`);

export default {
	verify,
	merchantInit,
	syncUsersFromZii,
	migrateMenu,
	migrateClientMenu,
	migrateClientMenuFile,
	progress,
};
